export default __webpack_public_path__ + "static/media/threads.747c15d1.svg";